module.exports = __webpack_public_path__ + "static/img/2.6297777.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/2.png
// module id = FBBa
// module chunks = 0